import { useEffect } from 'react';
import styled from 'styled-components';

import { DashboardActions, DashboardSelectors, AppSelectors } from '@store';
import { Box, Loading, Paper, PaperProps, Text } from '@components/common';
import { useAppDispatch, useAppSelector, useIsMounting } from '@hooks';
import { MysteryForestImage } from '@src/client/assets/images';

const Background = styled(Box)`
  background-image: ${`url(${MysteryForestImage})`};
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
`;

interface InfoCardProps extends PaperProps {
  title: string;
  content: string;
}

const InfoCard = ({ title, content, ...props }: InfoCardProps) => {
  return (
    <Paper {...props}>
      <Box display="flex" flexDirection="column" p={3}>
        <Text>{title}</Text>
        <Text variant="h4">{content}</Text>
      </Box>
    </Paper>
  );
};

export const Dashboard = () => {
  const dispatch = useAppDispatch();
  const isMounting = useIsMounting();

  const appStatus = useAppSelector(AppSelectors.selectAppStatus);
  const { isLoading, minted } = useAppSelector(
    DashboardSelectors.selectDashboardState
  );
  const lootBagSupply = 8000;
  const lootBagsWarped = minted.filter((tokenId) => tokenId < 8000).length;
  const arbitrumSupply = 11111 - 8999;
  const arbitrumClaimed = minted.filter((tokenId) => tokenId >= 9000).length;

  const loading = appStatus.loading || isMounting || isLoading;

  useEffect(() => {
    dispatch(DashboardActions.getSupplyData());
  }, []);

  return (
    <Background center flex={1}>
      {loading && <Loading />}
      {!loading && (
        <Box>
          <InfoCard
            title="Warped Loot Bags"
            content={`${lootBagsWarped.toString()} / ${lootBagSupply.toString()}`}
            mb={3}
          />
          <InfoCard
            title="Arbitrum Claimed"
            content={`${arbitrumClaimed.toString()} / ${arbitrumSupply.toString()}`}
          />
        </Box>
      )}
    </Background>
  );
};
